// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3duTw","head":"Table_head__3LP-L","col":"Table_col__1YAe9"};